import { SearchableItem } from './useMetricSearch';

export function searchMetrics(items: SearchableItem[], query: string) {
  if (query.trim() === '') return items;

  return items
    .filter((item) => item.label.toLowerCase().includes(query.toLowerCase()))
    .sort((a, b) => {
      // Shift action metrics to the end
      const aIsAction = a.metric.startsWith('action:');
      const bIsAction = b.metric.startsWith('action:');

      if (aIsAction && !bIsAction) return 1;
      if (!aIsAction && bIsAction) return -1;
      return 0;
    });
}
